import { axiosInstance } from './axiosConfig';
import { User } from './authService';

export type VerificationMethod = 'email' | 'sms' | 'totp' | 'backup';
export interface SecurityStatus { enabled: boolean; method: VerificationMethod | ''; email: string; email_verified: boolean; phone: string; sms_available: boolean; backup_codes_remaining: number; }
export interface ChallengeInfo { requires_2fa: boolean; method: VerificationMethod; destination: string; expires_in: number; }
export interface SpecialtyBranch { id: number; codigo: string; nombre: string; subramas: string[]; color: string; color_dark: string; icono: string; }

// Proofs and authentication remain in server sessions and HttpOnly cookies.
export async function securityRequest<T = { detail: string }>(path: string, data?: unknown, method: 'get' | 'post' | 'patch' = 'post'): Promise<T> {
    const response = await axiosInstance.request<T>({ url: `account-security/${path}/`, method, data });
    return response.data;
}
export const getSecurityStatus = () => securityRequest<SecurityStatus>('status', undefined, 'get');
export const getSpecialties = () => securityRequest<SpecialtyBranch[]>('specialties', undefined, 'get');
export async function saveOwnProfile(values: Record<string, string | number | File | null>): Promise<User> {
    const form = new FormData();
    Object.entries(values).forEach(([key, value]) => { if (value !== null) form.append(key, value instanceof File ? value : String(value)); });
    return securityRequest<User>('profile', form, 'patch');
}
export function securityError(error: unknown): string {
    const response = (error as { response?: { data?: unknown } })?.response?.data;
    if (typeof response === 'string') return 'No se pudo completar la solicitud. Intenta nuevamente.';
    if (Array.isArray(response)) return response.join(' ');
    if (response && typeof response === 'object') {
        return Object.values(response).flat().filter(v => typeof v === 'string').join(' ') || 'No se pudo completar la solicitud.';
    }
    return (error as Error)?.message || 'No se pudo conectar con el servidor.';
}
